export enum EmailTemplateType {
  TeamInvitation = 'TeamInvitation',
  TeamGroupEmail = 'TeamGroupEmail',
  GeneralEmail = 'GeneralEmail'
}
